module.exports = function() {
  return new Worker(__webpack_public_path__ + "eca49479f6b07abd1951.worker.js");
};